import { ref } from 'vue';
import { defineStore } from 'pinia';
import { SeoRawData } from '@/composables/useMeta';

type PageTemplate = {
  name: string;
  metafields: {
    templateDetails: object;
  };
};
export type RawPage = {
  title: string;
  content: string;
  handle: string;
  template: PageTemplate;
  seo: SeoRawData;
};

export const usePageStore = defineStore('pageStore', () => {
  const cachedPages = ref<RawPage[]>([]);
  const setCachedPages = (pages: RawPage[]) => {
    cachedPages.value = pages;
  };
  const findPageByHandle = (handle: string) => {
    return cachedPages.value.find((page) => page.handle === handle);
  };
  return {
    cachedPages,
    setCachedPages,
    findPageByHandle,
  };
});
